import { action, makeObservable, observable, reaction } from 'mobx';
import { addResizeObserver } from './resizeObserverCompat';

export class TextOverflowState {
  node: HTMLInputElement | null = null;
  isOverflow = false;
  observable: () => unknown;

  constructor(params: { observable: () => unknown }) {
    this.observable = params.observable;

    makeObservable(this, {
      isOverflow: observable.ref,
      calculateOverflow: action.bound,
      init: action,
    });
  }

  init(node: HTMLInputElement) {
    this.node = node;

    const disposers = [
      reaction(
        this.observable,
        () => {
          this.calculateOverflow();
        },
        {
          fireImmediately: true,
        },
      ),
      addResizeObserver(this.node, this.calculateOverflow),
    ];

    return () => {
      disposers.forEach((disposer) => disposer?.());
    };
  }

  _updateIsOverflow = action(() => {
    const { node } = this;

    if (!node) {
      return;
    }

    this.isOverflow = node.clientWidth + 1 < node.scrollWidth;
  });

  calculateOverflow() {
    requestAnimationFrame(this._updateIsOverflow);
  }
}
